"use strict";

exports.__esModule = true;
exports.AppIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _excluded = ["name", "alt", "theme", "ref"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var assetPath = process.env.ASSET_PATH || "";
var AppIcon = exports.AppIcon = (0, _styledComponents.withTheme)(function (_ref2) {
  var name = _ref2.name,
    alt = _ref2.alt,
    theme = _ref2.theme,
    _ref = _ref2.ref,
    extra = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: assetPath + "/" + theme.themeName + "/" + name + ".svg",
    alt: alt
  }, extra));
});